<!-- 专利求购 -->
<template>
  <div class="development">
    <div class="main">
      <div class="content">
        <div class="main_box">
          <div class="table">
            <table>
              <thead>
                <tr>
                  <th style="width: 26%">求购专利详情</th>
                  <th style="width: 12%">联系人</th>
                  <th style="width: 12%">联系方式</th>
                  <th>发布时间</th>
                  <th>QQ</th>
                  <th style="width: 12%">审核状态</th>
                  <th style="width: 8%">操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in tableData" :key="item.id">
                  <td style="width: 26%">{{ item.description }}</td>
                  <td style="width: 12%">{{ item.user.contact || "-" }}</td>
                  <td style="width: 12%">{{ item.user.tel || "-" }}</td>
                  <td>{{ item.create_time }}</td>
                  <td>{{ item.user.qq || "-" }}</td>
                  <td style="width: 12%">{{ getStatusText(item.status) }}</td>
                  <td
                    class="edit"
                    style="width: 8%"
                    @click="handleEdit(item.id)"
                  >
                    编辑
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="paging">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="pageSize"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getMyWantToBuy } from "../../api/userApi"; // 请替换为实际的API路径

export default {
  data() {
    return {
      tableData: [], // 表格数据
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示条数
      total: 0, // 总数据量
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    // 获取数据
    async fetchData() {
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
        };
        const res = await getMyWantToBuy(params);
        if (res.code === 1) {
          this.tableData = res.data;
          this.total = res.count;
        }
      } catch (error) {
        console.error("获取数据失败:", error);
      }
    },
    // 编辑跳转
    handleEdit(id) {
      this.$router.push({
        path: "/memberCenter/publish-patent-demand", // 根据你的实际路由配置调整
        query: { id }, // 传递专利求购ID
      });
    },
    // 状态转换
    getStatusText(status) {
      const statusMap = {
        0: "待审核",
        1: "审核通过",
        2: "已驳回",
      };
      return statusMap[status] || "未知状态";
    },

    // 每页条数改变
    handleSizeChange(val) {
      this.pageSize = val;
      this.fetchData();
    },

    // 当前页改变
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
  },
};
</script>

<style scoped lang="less">
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
  //   position: absolute;
}
.main {
  background: #f5f5f5;
  width: 100%;
  .main_box {
    width: 100%;
    // height: 1017px;
    background: #fff;
    border-radius: 10px;
    // padding: 15px 40px 35px 40px;
    .table {
      //   width: 100%;
      table {
        width: 100%;
        border-collapse: collapse; /* 合并单元格边框 */
        border-spacing: 0; /* 移除单元格之间的间距 */
        margin: 15px 0 35px 0;
        th,
        td {
          /* 强制不换行 */
          white-space: nowrap;
          /* 内容超出容器隐藏 */
          overflow: hidden;
          /* 使用省略号表示被隐藏的内容 */
          text-overflow: ellipsis;
          /* 设置最大宽度或固定宽度 */
          width: 14%; /* 根据实际情况调整 */
          /* 确保内容不会自动扩展td的宽度 */
          display: inline-block;
          /* 可选：设定一个固定高度，如果适用 */
          height: 50px; /* 根据实际情况调整 */
          line-height: 50px;
        }
        thead {
          border-radius: 5px;
          background: #175dc2;

          tr {
            height: 50px;
            th {
              // width: 10%;
              font-family: PingFang SC, PingFang SC;

              font-weight: 600;
              font-size: 14px;
              color: #ffffff;
            }
          }
        }
        tbody {
          tr:nth-child(odd) {
          }
          tr:nth-child(even) {
            background: #f2f4fe;
            border-radius: 5px;
          }
          tr {
            td {
              // height: 50px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 14px;
              color: #121212;
              // white-space: nowrap; /* 禁止文字换行 */
              // overflow: hidden; /* 超出部分隐藏 */
              // text-overflow: ellipsis;
            }
          }
          .edit {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;
            color: #175dc2;
            cursor: pointer;
          }
        }
      }
    }
    .paging {
      display: flex;
      justify-content: flex-end;
      padding-right: 45px;
      margin-bottom: 18px;
    }
  }
}
</style>
